<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 5/10/2021
  -->

<template>
	<el-form :model="valueData" :rules="rules" ref="mainForm" class="qwoach-form pb-4"
			 @submit.native.prevent="() => {}">
		<div>
			<div>
				<FormCheckboxRow
					v-if="!valueData.hasSetupFee && !valueData.isActive()"
					title="Include setup fee"
					v-model="valueData.hasSetupFee"
					tooltip-text="An option to charge your clients a one-time fee that will be applied on top of the initial subscription fee."/>

				<div v-if="valueData.hasSetupFee && !valueData.isActive()" style="padding-bottom: 10px">

					<div class="card" style="margin: -10px; padding: 10px">
						<FormCheckboxRow
							title="Include setup fee"
							v-model="valueData.hasSetupFee"
							tooltip-text="An option to charge your clients a one-time fee that will be applied on top of the initial subscription fee."/>

						<FormNumberRow
							prop="setupFeeAmount"
							title="Fee amount"
							v-model="valueData.setupFeeAmount"
							:title-prefix="currencyString"
							width="50"
							placeholder="0"
							tooltip-text="One-time fee. <br/><br/>The total amount for the first payment for your client would be calculated as a sum of the setup fee and the subscription amount for the first billing period specified below"/>

						<FormTextRow
							prop="setupFeeDescription"
							title="Client text"
							v-model="valueData.setupFeeDescription"
							tooltip-text="A description that will be shown to your client during checkout."/>
					</div>

				</div>

			</div>
			<FormNumberRow
				prop="recurringAmount"
				title="Billing amount"
				v-model="valueData.recurringAmount"
				:title-prefix="currencyString"
				width="50"
				placeholder="0"
				tooltip-text="Recurring amount that your clients will be charged once they subscribe to your coaching"/>

			<FormRow
				title="Charge every"
				tooltip-text="How often to charge your clients"
			>
				<div class="row mx-0">
					<FormSelectRow
						style="width: 50px;"
						v-model="valueData.recurringIntervalCount"
						:options="recurringIntervalCountOptions"/>
					<FormSelectRow
						class="col"
						v-model="valueData.recurringInterval"
						:options="recurringIntervalOptions"
						@change="onRecurringIntervalChange"/>
				</div>

			</FormRow>
		</div>

	</el-form>
</template>

<script>

import FormRow from "@/core/components/Form/Base/FormRow.vue";
import FormSelectRow from "@/core/components/Form/FormSelectRow.vue";
import BaseVModelView from "@/core/components/BaseVModelView.vue";
import FormNumberRow from "@/core/components/Form/FormNumberRow.vue";
import FormCheckboxRow from "@/core/components/Form/FormCheckboxRow.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";

let amountTrigger = [
	{
		required: true,
		whitespace: false,
		validator: (rule, value, callback, source, options) => {
			console.log("value = ", value)
			let errorMsg
			if (!value) {
				errorMsg = 'Please specify the amount'
			} else if (value < 0) {
				errorMsg = 'The amount must be positive'
			}
			// let errorMsg = value ? undefined : "Please check terms"
			callback(errorMsg);
		},
		trigger: 'validate'
	},
]
export default {
	name: "RecurringBillingDataPicker",
	components: {FormTextRow, FormCheckboxRow, FormNumberRow, FormSelectRow, FormRow},
	extends: BaseVModelView,

	data() {
		return {
			recurringIntervalCountOptions: [],
			rules: {
				setupFeeAmount: amountTrigger,
				recurringAmount: amountTrigger,
				setupFeeDescription: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let errorMsg
							if (!value) errorMsg = 'Please add text'
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				]
			}
		}
	},

	mounted() {
		this.onRecurringIntervalChange()
	},

	methods: {
		onRecurringIntervalChange() {
			this.recalculateRecurringIntervalCountOptions()
			this.valueData.recurringIntervalCount = Math.min(this.valueData.recurringIntervalCount, this.recurringIntervalCountOptions.length)
		},

		recalculateRecurringIntervalCountOptions() {
			let val = []
			let maxCount = 31
			switch (this.valueData.recurringInterval) {
				case 'month':
					maxCount = 12;
					break;
				case 'year':
					maxCount = 1;
					break;
				case 'day':
					maxCount = 31;
					break;
				case 'week':
					maxCount = 4;
					break;

			}
			for (let i = 0; i < maxCount; ++i) {
				val.push(i + 1)
			}
			this.recurringIntervalCountOptions = val
			console.log("recalculateRecurringIntervalCountOptions = ", this.recurringIntervalCountOptions, ", this.recurringBillingData.recurringInterval = ", this.valueData.recurringInterval)
		},
	},

	computed: {

		recurringIntervalOptions() {
			return ['month', 'year', 'day', 'week']
		},

	},
}
</script>

<style lang="scss">

</style>
